import { render, staticRenderFns } from "./My360FormGroup.vue?vue&type=template&id=22c10f70&lang=html&"
import script from "./My360FormGroup.vue?vue&type=script&lang=js&"
export * from "./My360FormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports